import Toast from 'react-native-toast-message';
import PastelToast from '../PastelToast';

export const ToastProvider = () => {
  return (
    <Toast
      swipeable={false}
      config={{
        success: ({ text1, props }) => {
          return <PastelToast message={text1} props={props} />;
        },
      }}
    />
  );
};
